
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ProjectLotEmployeeCurrentResource,
  ProjectLotEmployeeEventResource,
  UpdateProjectLotEmployeesRequest,
} from '../models';
import {
    ProjectLotEmployeeCurrentResourceFromJSON,
    ProjectLotEmployeeCurrentResourceToJSON,
    ProjectLotEmployeeEventResourceFromJSON,
    ProjectLotEmployeeEventResourceToJSON,
    UpdateProjectLotEmployeesRequestFromJSON,
    UpdateProjectLotEmployeesRequestToJSON,
} from '../models';

export interface GetProjectEmployeeHistoryRequest {
    correlationId: string;
}

export interface GetProjectEmployeesRequest {
    correlationId: string;
}

export interface GetProjectLotEmployeeHistoryRequest {
    correlationId: string;
    lotId: string;
}

export interface GetProjectLotEmployeesRequest {
    correlationId: string;
    lotId: string;
}

export interface UpdateProjectEmployeesRequest {
    correlationId: string;
    updateProjectLotEmployeesRequest: UpdateProjectLotEmployeesRequest;
}

export interface UpdateProjectLotEmployeesOperationRequest {
    correlationId: string;
    lotId: string;
    updateProjectLotEmployeesRequest: UpdateProjectLotEmployeesRequest;
}

/**
 * 
 */
export class ProjectLotEmployeesApi extends runtime.BaseAPI {

    /**
     * Get full assignment event history for a project
          */
    async getProjectEmployeeHistoryRaw(requestParameters: GetProjectEmployeeHistoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ProjectLotEmployeeEventResource>>> {
        if (requestParameters['correlationId'] == null) {
            throw new runtime.RequiredError(
                'correlationId',
                'Required parameter "correlationId" was null or undefined when calling getProjectEmployeeHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ProjectLotEmployeeEventResource>>({
            path: `/api/v1/compliance/projects/{correlationId}/history`.replace(`{${"correlationId"}}`, encodeURIComponent(String(requestParameters['correlationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ProjectLotEmployeeEventResourceFromJSON);
        return response;
    }

    /**
     * Get full assignment event history for a project
          */
    async getProjectEmployeeHistory(requestParameters: GetProjectEmployeeHistoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ProjectLotEmployeeEventResource>> {
        const response = await this.getProjectEmployeeHistoryRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get current employee assignments for a project (no lot)
          */
    async getProjectEmployeesRaw(requestParameters: GetProjectEmployeesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectLotEmployeeCurrentResource>> {
        if (requestParameters['correlationId'] == null) {
            throw new runtime.RequiredError(
                'correlationId',
                'Required parameter "correlationId" was null or undefined when calling getProjectEmployees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectLotEmployeeCurrentResource>({
            path: `/api/v1/compliance/projects/{correlationId}/employees`.replace(`{${"correlationId"}}`, encodeURIComponent(String(requestParameters['correlationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectLotEmployeeCurrentResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get current employee assignments for a project (no lot)
          */
    async getProjectEmployees(requestParameters: GetProjectEmployeesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectLotEmployeeCurrentResource> {
        const response = await this.getProjectEmployeesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get assignment event history for a specific lot
          */
    async getProjectLotEmployeeHistoryRaw(requestParameters: GetProjectLotEmployeeHistoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ProjectLotEmployeeEventResource>>> {
        if (requestParameters['correlationId'] == null) {
            throw new runtime.RequiredError(
                'correlationId',
                'Required parameter "correlationId" was null or undefined when calling getProjectLotEmployeeHistory().'
            );
        }

        if (requestParameters['lotId'] == null) {
            throw new runtime.RequiredError(
                'lotId',
                'Required parameter "lotId" was null or undefined when calling getProjectLotEmployeeHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ProjectLotEmployeeEventResource>>({
            path: `/api/v1/compliance/projects/{correlationId}/lots/{lotId}/history`.replace(`{${"correlationId"}}`, encodeURIComponent(String(requestParameters['correlationId']))).replace(`{${"lotId"}}`, encodeURIComponent(String(requestParameters['lotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ProjectLotEmployeeEventResourceFromJSON);
        return response;
    }

    /**
     * Get assignment event history for a specific lot
          */
    async getProjectLotEmployeeHistory(requestParameters: GetProjectLotEmployeeHistoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ProjectLotEmployeeEventResource>> {
        const response = await this.getProjectLotEmployeeHistoryRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get current employee assignments for a specific lot
          */
    async getProjectLotEmployeesRaw(requestParameters: GetProjectLotEmployeesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectLotEmployeeCurrentResource>> {
        if (requestParameters['correlationId'] == null) {
            throw new runtime.RequiredError(
                'correlationId',
                'Required parameter "correlationId" was null or undefined when calling getProjectLotEmployees().'
            );
        }

        if (requestParameters['lotId'] == null) {
            throw new runtime.RequiredError(
                'lotId',
                'Required parameter "lotId" was null or undefined when calling getProjectLotEmployees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectLotEmployeeCurrentResource>({
            path: `/api/v1/compliance/projects/{correlationId}/lots/{lotId}/employees`.replace(`{${"correlationId"}}`, encodeURIComponent(String(requestParameters['correlationId']))).replace(`{${"lotId"}}`, encodeURIComponent(String(requestParameters['lotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectLotEmployeeCurrentResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get current employee assignments for a specific lot
          */
    async getProjectLotEmployees(requestParameters: GetProjectLotEmployeesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectLotEmployeeCurrentResource> {
        const response = await this.getProjectLotEmployeesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Replace assigned employees for a project (no lot)
          */
    async updateProjectEmployeesRaw(requestParameters: UpdateProjectEmployeesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectLotEmployeeCurrentResource>> {
        if (requestParameters['correlationId'] == null) {
            throw new runtime.RequiredError(
                'correlationId',
                'Required parameter "correlationId" was null or undefined when calling updateProjectEmployees().'
            );
        }

        if (requestParameters['updateProjectLotEmployeesRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProjectLotEmployeesRequest',
                'Required parameter "updateProjectLotEmployeesRequest" was null or undefined when calling updateProjectEmployees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ProjectLotEmployeeCurrentResource>({
            path: `/api/v1/compliance/projects/{correlationId}/employees`.replace(`{${"correlationId"}}`, encodeURIComponent(String(requestParameters['correlationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProjectLotEmployeesRequestToJSON(requestParameters['updateProjectLotEmployeesRequest']),
        }, initOverrides);

        if (response._data) { response._data=ProjectLotEmployeeCurrentResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Replace assigned employees for a project (no lot)
          */
    async updateProjectEmployees(requestParameters: UpdateProjectEmployeesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectLotEmployeeCurrentResource> {
        const response = await this.updateProjectEmployeesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Replace assigned employees for a specific lot
          */
    async updateProjectLotEmployeesRaw(requestParameters: UpdateProjectLotEmployeesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectLotEmployeeCurrentResource>> {
        if (requestParameters['correlationId'] == null) {
            throw new runtime.RequiredError(
                'correlationId',
                'Required parameter "correlationId" was null or undefined when calling updateProjectLotEmployees().'
            );
        }

        if (requestParameters['lotId'] == null) {
            throw new runtime.RequiredError(
                'lotId',
                'Required parameter "lotId" was null or undefined when calling updateProjectLotEmployees().'
            );
        }

        if (requestParameters['updateProjectLotEmployeesRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProjectLotEmployeesRequest',
                'Required parameter "updateProjectLotEmployeesRequest" was null or undefined when calling updateProjectLotEmployees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ProjectLotEmployeeCurrentResource>({
            path: `/api/v1/compliance/projects/{correlationId}/lots/{lotId}/employees`.replace(`{${"correlationId"}}`, encodeURIComponent(String(requestParameters['correlationId']))).replace(`{${"lotId"}}`, encodeURIComponent(String(requestParameters['lotId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProjectLotEmployeesRequestToJSON(requestParameters['updateProjectLotEmployeesRequest']),
        }, initOverrides);

        if (response._data) { response._data=ProjectLotEmployeeCurrentResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Replace assigned employees for a specific lot
          */
    async updateProjectLotEmployees(requestParameters: UpdateProjectLotEmployeesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectLotEmployeeCurrentResource> {
        const response = await this.updateProjectLotEmployeesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
